<template>
  <div>
    <!-- 费用详情 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>费用详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <div class="everyItem">
        <div class="tableOrder">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column prop="addtime" label="业务周期" width="180"></el-table-column>
            <el-table-column prop="bill" label="账号" width="180"></el-table-column>
            <el-table-column prop="orderid" label="订单号"></el-table-column>
            <el-table-column prop="should_close" label="应结算金额(元)"></el-table-column>
            <el-table-column prop="num_price" label="未结算金额(元)"></el-table-column>
            <el-table-column prop="num_price" label="未开发票金额(元)"></el-table-column>
            <el-table-column prop="state" label="打款状态">
              <template slot-scope="scope">
                <img src="@/images/distributor/dl.png" alt  v-if="scope.row.state=='1'||scope.row.state=='2'||scope.row.state=='6'" />
                <img src="@/images/distributor/dh.png" alt  v-if="scope.row.state=='3'" />
                <span style="margin-left:10px">
                  {{ scope.row.state == 1 ? "已开发票" : scope.row.state == 2 ? "已打款" : scope.row.state == 3 ? "未开发票" : scope.row.state == 6 ? "已确认":"" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="凭证">
              <template slot-scope="scope">
                <el-button type="text" @click="infoFn(scope.row)">查看详情</el-button>
                <el-button type="text" @click="infoFns(scope.row)" v-if=" scope.row.state=='3'" >确认结算</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="data.page"  @current-change="currenchange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 查看详情开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单单独明细查询"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="36%"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="tableOrder">
        <el-table
          :data="tableData1"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="CreateTime" label="业务时间" width="180"></el-table-column>
          <el-table-column prop="OrderID" label="订单号"></el-table-column>
          <el-table-column prop="ActFee" label="金额(元)"></el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="paginationS">
        <span class="demonstration">共{{total1}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total1" :current-page.sync="data1.page"  @current-change="currenchange1"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 查看详情结束 -->
  </div>
</template>

<script>
import {getCloseList,getInfoCloseDetailList,affirm} from '@/request/distributor.js'
export default {
  data() {
    return {
      infoDialogVisible: false, // 查看详情
      tableData: [
      ],
      tableData1:[],
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8
      },
      total:0,
      data1:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8
      },
      total1:1,
    };
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      getCloseList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total =res.data.result.total
          this.tableData.map(item=>{
            item.num_price = item.should_close - item.should_unfinished
          })
        }
      })
    },
       // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    currenchange1(e){
      this.data1.page = e
      this.detail()
    },
    // 查看详情
    infoFn(row) {
      this.infoDialogVisible = true;
      this.detail(row)
    },
    detail(row){
      let data = {
        token: this.data1.token,
        id:row.id,
        page:this.data1.page,
        page_size:this.data1.page_size
      }
      getInfoCloseDetailList(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.tableData1 = res.data.result.data
          this.total1 = res.data.result.total
        }
      })
    },
    // 查看详情X
    infoHandleClose() {
      this.infoDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    // 确认结算
    infoFns(row){
      let data = {
        token: this.data1.token,
        id:row.id
      }
      affirm(data).then(res=>{
        if(res.data.status=='ok'){
           this.getList()
           this.$message.success('确认结算')
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.tableOrder {
  .el-input {
    width: 100px;
    height: 30px;
    background: #f7f7fa;
    border-radius: 4px;
  }
  /deep/.el-input__inner {
    width: 100px;
    height: 30px;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    text-align: center;
  }
}
.everyItem {
  margin-bottom: 20px;
  .everyItemOne {
    display: flex;
    border: 1px solid #e5e5ea;
    div:nth-child(1) {
      width: 100%;
      height: 50px;
      padding: 0 10px;
      line-height: 50px;
      background: #ffffff;
      margin-right: 90px;
    }
    div:not(div:nth-child(1)) {
      width: 100%;
      height: 50px;
      line-height: 50px;
      background: #ffffff;
      text-align: center;
    }
    div {
      > span:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: #000000;
      }
    }
    .el-button {
      width: 80px;
      height: 30px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      line-height: 05px;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
}

// 分页
.paginationS {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 36px auto 26px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #000000;
}
/deep/.el-dialog__headerbtn {
  position: absolute;
  top: 5px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
</style>